module.exports = __webpack_public_path__ + "img/adidas_01.f707cb24.jpg";